// extracted by mini-css-extract-plugin
export var cartContainer = "_k4-4";
export var gray = "_k4-1";
export var itemContainer = "_k4-2";
export var itemDetails = "_k4-3";
export var strong = "_k4-0";